import React from 'react'

export const PageNotFound = () => {
  return (
    <div className="container d-flex flex-column justify-content-center align-items-center vh-100">
    <img
      src="assets/images/line-chart.jpg" 
      alt="Page Not Found"
      className="img-fluid mb-4"
      width={400}
      height={500}
    />
    <h1 className="text-center">Oops! Page Not Found</h1>
    <p className="text-center">The page you are looking for does not exist.</p>
  </div>
  )
}
